import type { RegisterCustomDirective } from 'src/plugins/custom-directives'
import type { Directive } from 'vue'

export const passwordManagerIgnore: RegisterCustomDirective = {
  name: 'password-manager-ignore',
  directive: {
    mounted: (el: HTMLElement) => {
      el.setAttribute('data-1p-ignore', '')
      el.setAttribute('data-bwignore', '')
      el.setAttribute('data-lpignore', 'true')
      el.setAttribute('data-form-type', 'other')
    }
  }
}
